import React from "react";
import BatchAuditReport from "../../../common/reports/audit/batchAuditReport";

const BatchAuditReportIndex = props => {
  return <BatchAuditReport {...props} collabType="Pharma Co" />;
};

export default BatchAuditReportIndex;
